import React from 'react';

/**
 * Password visibility toggle button.
 *
 * Toggle-button pattern: the accessible name stays constant ("Show password")
 * and the on/off state is conveyed through aria-pressed, so screen readers
 * announce e.g. "Show password, toggle button, pressed" rather than a name
 * that contradicts the state.
 */
interface PasswordToggleProps {
  shown: boolean;
  onToggle: () => void;
}

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const PasswordToggle: React.FC<PasswordToggleProps> = ({ shown, onToggle }) => (
  <button
    type="button"
    className="password-toggle"
    onClick={onToggle}
    aria-label="Show password"
    aria-pressed={shown}
  >
    {shown ? <EyeOffIcon /> : <EyeIcon />}
  </button>
);

export default PasswordToggle;
